// extracted by mini-css-extract-plugin
export default {"paymentSection":"o7-z"};